!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self,function(){var n=e.Cookies,o=e.Cookies=t();o.noConflict=function(){return e.Cookies=n,o}}())}(this,(function(){"use strict";function e(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)e[o]=n[o]}return e}var t=function t(n,o){function r(t,r,i){if("undefined"!=typeof document){"number"==typeof(i=e({},o,i)).expires&&(i.expires=new Date(Date.now()+864e5*i.expires)),i.expires&&(i.expires=i.expires.toUTCString()),t=encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g,decodeURIComponent).replace(/[()]/g,escape);var c="";for(var u in i)i[u]&&(c+="; "+u,!0!==i[u]&&(c+="="+i[u].split(";")[0]));return document.cookie=t+"="+n.write(r,t)+c}}return Object.create({set:r,get:function(e){if("undefined"!=typeof document&&(!arguments.length||e)){for(var t=document.cookie?document.cookie.split("; "):[],o={},r=0;r<t.length;r++){var i=t[r].split("="),c=i.slice(1).join("=");try{var u=decodeURIComponent(i[0]);if(o[u]=n.read(c,u),e===u)break}catch(e){}}return e?o[e]:o}},remove:function(t,n){r(t,"",e({},n,{expires:-1}))},withAttributes:function(n){return t(this.converter,e({},this.attributes,n))},withConverter:function(n){return t(e({},this.converter,n),this.attributes)}},{attributes:{value:Object.freeze(o)},converter:{value:Object.freeze(n)}})}({read:function(e){return'"'===e[0]&&(e=e.slice(1,-1)),e.replace(/(%[\dA-F]{2})+/gi,decodeURIComponent)},write:function(e){return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,decodeURIComponent)}},{path:"/"});return t}));


var adev, map, infoWindow, marker;

function toDMS(deg) {
    var d = Math.floor(deg);
    var min = Math.floor((deg - d) * 60);
    var sec = ((deg - d - min / 60) * 3600).toFixed(0);
    return d + "°" + min + "'" + sec + "\"";
}

function convertLatLngToDMS(lat, lng) {
    var latDMS = lat >= 0 ? "N" : "S";
    var lngDMS = lng >= 0 ? "E" : "W";
    
    lat = Math.abs(lat);
    lng = Math.abs(lng);
    
    var latDMSString = toDMS(lat);
    var lngDMSString = toDMS(lng);
    
    return latDMSString + " " + latDMS + " " + lngDMSString + " " + lngDMS;
}

function placeMarker(e) {
    null == marker ? marker = new google.maps.Marker({
        position: e,
        map: map
    }) : marker.setPosition(e)
}

window.adev = window.adev || {}, window.adev.keyiconchecking = null,
    function(n) {
        "use strict";
        (adev = {
            init: function() {
                this.option_toggle(), 0 !== $("#add-to-cart-form").length && this.keyIcon(), this.map()
            },
            keyIcon: function() {
                var e = this;
                clearTimeout(window.adev.keyiconchecking), window.adev.keyiconchecking = setTimeout(function() {
                    $(".key_layout_sub").length ? $(".key_layout_sub").html('<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="2"><path stroke-dasharray="60" stroke-dashoffset="60" d="M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3Z"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.5s" values="60;0"/></path><path stroke-dasharray="14" stroke-dashoffset="14" d="M8 14C8.5 15.5 9.79086 17 12 17C14.2091 17 15.5 15.5 16 14"><animate fill="freeze" attributeName="stroke-dashoffset" begin="1s" dur="0.2s" values="14;0"/></path></g><g fill="currentColor" fill-opacity="0"><ellipse cx="9" cy="9.5" rx="1" ry="1.5"><animate fill="freeze" attributeName="fill-opacity" begin="0.6s" dur="0.2s" values="0;1"/></ellipse><ellipse cx="15" cy="9.5" rx="1" ry="1.5"><animate fill="freeze" attributeName="fill-opacity" begin="0.8s" dur="0.2s" values="0;1"/></ellipse></g></svg>') : e.keyIcon()
                }, 300)
            },
            option_toggle: function() {
                var t = this;
                this.checkingforPhotosOption(), n(".pplr-wrapper.pplr-.cp-sel-Photos, .pplr-wrapper.pplr-2.cp-sel-Photos").hide(), n('.pplr-wrapper.pplr-.cp-sel-Photos input[type="file"], .pplr-wrapper.pplr-2.cp-sel-Photos input[type="file"]').removeAttr("required"), n(".adev-custom-buttons span").on("click", function() {
                    var e = n(this),
                        o = e.data("adev-option");
                    n(".adev-custom-buttons span").removeClass("active"), e.addClass("active"), n(".adev-handwritting-tip, .adev-handwritting-images").hide(), "handwritting" === o ? (n(".adev-handwritting-tip, .adev-handwritting-images").show(), n(".pplr-wrapper.pplr-.cp-sel-Photos, .pplr-wrapper.pplr-2.cp-sel-Photos").show(), n('.pplr-wrapper.pplr-.cp-sel-Photos input[type="file"], .pplr-wrapper.pplr-2.cp-sel-Photos input[type="file"]').attr("required", "required"), n('.pplr-wrapper.pplr-.cp-sel-Photos input[type="file"], .pplr-wrapper.pplr-2.cp-sel-Photos input[type="file"]').removeAttr("disabled"), n("form#add-to-cart-form").removeClass("adev_map_active"), n(".adev-map-cord-selector").hide(), t.change_input(""), n("form#add-to-cart-form").addClass("adev_handwritting_active"), n(".pplr-wrapper.pplr-text input, .pplr-wrapper.pplr-text textarea").removeAttr("required"), n(".adev-product-three form#add-to-cart-form.adev_handwritting_active>div:first-child div#pplr-7594615800007 .pplr-wrapper[data-main='6'] [required]").removeAttr("required"), n(".adev-product-three form#add-to-cart-form.adev_handwritting_active>div:first-child div#pplr-7594615800007 .pplr-wrapper[data-main='7'] [required]").removeAttr("required")) : ((function(){try{pplr_delete(2, !0)}catch(e){}})(), n(".pplr-wrapper.pplr-text input, .pplr-wrapper.pplr-text textarea").attr("required", "required"), n(".pplr-wrapper.pplr-.cp-sel-Photos, .pplr-wrapper.pplr-2.cp-sel-Photos").hide(), n('.pplr-wrapper.pplr-.cp-sel-Photos input[type="file"], .pplr-wrapper.pplr-2.cp-sel-Photos input[type="file"]').removeAttr("required"), n("form#add-to-cart-form").removeClass("adev_handwritting_active"), "text" == o ? (n("form#add-to-cart-form").removeClass("adev_map_active"), n(".adev-map-cord-selector").hide(), t.change_input("")) : (n("form#add-to-cart-form").addClass("adev_map_active"), n(".adev-map-cord-selector").show()))
                })
            },
            checkingforPhotosOption: function() {
                var e = this;
                setTimeout(function() {
                    0 == n(".pplr-wrapper.pplr-.cp-sel-Photos, .pplr-wrapper.pplr-2.cp-sel-Photos").length ? e.checkingforPhotosOption() : (n(".pplr-wrapper.pplr-.cp-sel-Photos, .pplr-wrapper.pplr-2.cp-sel-Photos").hide(), n('.pplr-wrapper.pplr-.cp-sel-Photos input[type="file"], .pplr-wrapper.pplr-2.cp-sel-Photos input[type="file"]').removeAttr("required"))
                }, 400)
            },
            change_input: function(o) {
                n(".pplr-wrapper").each(function() {
                    var e = $(this);
                    e.children("input").first().val(o).trigger("input"), e.children("textarea").first().val(o).trigger("input")
                })
            },
            map: function() {
                if ($(".adev-map").length) {
                    var a = this,
                        e = (a.change_input(convertLatLngToDMS((e = {
                            lat: 55.679140329589515,
                            lng: 12.56900668045048
                        }).lat, e.lng)), map = new google.maps.Map(document.querySelector(".adev-map"), {
                            zoom: 16,
                            center: e
                        }), (infoWindow = new google.maps.InfoWindow({
                            content: JSON.stringify(e),
                            position: e
                        })).open(map), map.addListener("click", e => {
                            infoWindow.close(), (infoWindow = new google.maps.InfoWindow({
                                position: e.latLng
                            })).setContent(JSON.stringify(e.latLng)), infoWindow.open(map), a.change_input(convertLatLngToDMS(e.latLng.lat(), e.latLng.lng()))
                        }), document.querySelector("[data-adev-map-search]")),
                        o = new google.maps.places.SearchBox(e);
                    map.controls[google.maps.ControlPosition.TOP_LEFT].push(e), map.addListener("bounds_changed", () => {
                        o.setBounds(map.getBounds());
                        var e = {
                            lat: map.center.lat(),
                            lng: map.center.lng()
                        };
                        // console.log(e); 
                        infoWindow.close(), (infoWindow = new google.maps.InfoWindow({
                            content: JSON.stringify(e, null, 2),
                            position: e
                        })).open(map), a.change_input(convertLatLngToDMS(e.lat, e.lng))
                    });
                    let n = [];
                    o.addListener("places_changed", () => {
                        var e = o.getPlaces();
                        // console.log(e),
                        if ( 0 != e.length) {
                            n.forEach(e => {
                                e.setMap(null)
                            }), n = [];
                            const t = new google.maps.LatLngBounds;
                            // console.log(t);
                            e.forEach(e => {
                                var o;
                                e.geometry && e.geometry.location ? (infoWindow.close(), o = {
                                    lat: e.geometry.location.lat(),
                                    lng: e.geometry.location.lng()
                                }, a.change_input(convertLatLngToDMS(o.lat, o.lng)), (infoWindow = new google.maps.InfoWindow({
                                    content: JSON.stringify(o, null, 2),
                                    position: e
                                })).open(map), o = {
                                    url: e.icon,
                                    size: new google.maps.Size(71, 71),
                                    origin: new google.maps.Point(0, 0),
                                    anchor: new google.maps.Point(17, 34),
                                    scaledSize: new google.maps.Size(25, 25)
                                }, n.push(new google.maps.Marker({
                                    map: map,
                                    icon: o,
                                    title: e.name,
                                    position: e.geometry.location
                                })), e.geometry.viewport ? t.union(e.geometry.viewport) : t.extend(e.geometry.location)) : console.log("Returned place contains no geometry")
                            }), map.fitBounds(t)
                        }
                    })
                }
            },
            ajax_get: function(e, o) {
                n.ajax({
                    url: e,
                    type: "GET"
                }).done(function(e) {
                    "function" == typeof o ? o(e) : console.log(e)
                })
            },
            ajax_post: function(e, o, t) {
                n.ajax({
                    url: e,
                    type: "POST",
                    data: o
                }).done(function(e) {
                    "function" == typeof t ? t(e) : console.log(e)
                })
            }
        }).init()
    }(jQuery),
    function(o) {
        o("[data-accordion]").each(function() {
            var e = o(this);
            e.children("[data-accordion-title]").off().on("click", function() {
                e.toggleClass("opened"), e.find("[data-accordion-content]").slideToggle()
            })
        })
    }(jQuery), $(function() {
        var o = !1;
        $(document).on("focus", ".product-personalizer .pplr_monogram", function(e) {
            o ? $("body").removeClass("adev_show_symbols") : $("body").addClass("adev_show_symbols")
        }), $(document).on("click", ".product-personalizer .key_layout_sub", function(e) {
            o = !o, $("body").removeClass("adev_show_symbols")
        })
    }), window.adevNew = window.adevNew || {}, window.adevNew = {
        savings() {
            const o = $("[data-adev-savings-percentage]");
            var e, t;
            0 !== o.length && (e = o.data("price"), "" != (t = o.data("compare-at-price"))) && (o.html("<span>-" + ((t - e) / t * 100).toFixed(0) + "%</span>"), document.addEventListener("adev:variant_changed", function(e) {
                e = e.detail;
                e.compare_at_price > e.price ? o.html("<span>-" + ((e.compare_at_price - e.price) / e.compare_at_price * 100).toFixed(0) + "%</span>") : o.html(" ")
            }))
        },
        annoucementBar() {
            $("body").css({
                "--adev-topbar-height": $(".adev-announcement-items").outerHeight() + "px"
            });
            var o = $(".adev-announcement-items");
            const t = o.find(".adev__announcement-item");
            o = o.data("autoplay-seconds");
            if (0 !== t.length) {
                let e = 0;
                $(t[e]).addClass("active"), setInterval(() => {
                    $(t[e]).removeClass("active"), e = (e + 1) % t.length, $(t[e]).addClass("active"), $("body").css({
                        "--adev-topbar-height": $(".adev-announcement-items").outerHeight() + "px"
                    })
                }, o)
            }
        },
        quantitySelector(){
			$(document).on('click', '[data-adev-quantity-selector] [data-adev-quantity-up]', function(e) {
				e.preventDefault();
				const spinner = $(this).parent('[data-adev-quantity-selector]');
				const input = spinner.find('[data-adev-quantity-value]');
				const spinnerMax = input.attr('max') || 1000;
				let value = parseInt(input.val(), 10);
				value = isNaN(value) ? 0 : value;
				value++;
				if (spinnerMax >= value) {
				  input.attr('value', value).val(value).trigger('change');
				  spinner.trigger('adev:quantity:change', value);
				}
			});
			  
			$(document).on('click', '[data-adev-quantity-selector] [data-adev-quantity-down]', function(e) {
				e.preventDefault();
				const spinner = $(this).parent('[data-adev-quantity-selector]');
				const input = spinner.find('[data-adev-quantity-value]');
				const spinnerMin = input.attr('min') || 1;
				let value = parseInt(input.val(), 10);
				value = isNaN(value) ? 0 : value;
				if (value !== 0) {
				  value--;
				  if (spinnerMin <= value) {
					input.attr('value', value).val(value).trigger('change');
					spinner.trigger('adev:quantity:change', value);
				  }
				}
			});
		},
        drawer(){
			$(document).on('adev:drawer:open', function(e, id){
				const selected_drawer = $('[data-drawer='+ id +']');
				if(selected_drawer.length) {
					$(document).trigger('adev:popup:close');
					$('[data-drawer]').removeClass('opened').attr('tabindex', '-1')
					selected_drawer.addClass('opened').attr('tabindex', '0').find('[data-close-drawer]').trigger('focus')
					$('[data-adev-drawer-overlay]').addClass('opened');
					$('html').addClass('noscroll');
					$(document).trigger('adev:drawer:opened', id)
				}
			})

			$(document).on('adev:drawer:close', function(e, id){
				id = id || '';
				$('[data-drawer]').removeClass('opened').attr('tabindex', '-1')
				$('[data-adev-drawer-overlay]').removeClass('opened');
				$('html').removeClass('noscroll');
				$(document).trigger('adev:drawer:closed', id)
			})

			$(document).on('click', '[data-open-drawer]', function(e){
				e.preventDefault();
				const id = $(this).data('open-drawer');
				$(document).trigger('adev:drawer:open', id);
			})

			$(document).on('click', '[data-close-drawer], [data-adev-drawer-overlay]', function(e){
				e.preventDefault();
				$(document).trigger('adev:drawer:close');
			})
		},
    }, window.adevNew.savings(), window.adevNew.quantitySelector(), window.adevNew.drawer(), window.adevNew.annoucementBar();


(function ($) {
    "use strict";
    
    document.addEventListener("adev:product-card:gallery-images", function (e) {
        $('[data-adev-product-card-images="wrap"]:not(.slick-initialized)').each(function () {
            const wrap = $(this);

            wrap.slick({
                autoplay: false,
                arrows: true,
                prevArrow: '<div class="slick-prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><g stroke-width="1.5" fill="none"><path d="M15 6l-6 6l6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></g></svg></div>',
                nextArrow: '<div class="slick-next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true" focusable="false" width="1em" height="1em" style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);" preserveAspectRatio="xMidYMid meet" viewBox="0 0 24 24"><g stroke-width="1.5" fill="none"><path d="M9 6l6 6l-6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></g></svg></div>',
                dots: true,
                infinite: false,
                speed: 300,
                slidesToShow: 1,
                slidesToScroll: 1,
                slide: window.innerWidth >= 1024 ? '[data-adev-product-card-images]' : '[data-adev-product-card-images="mobile"]',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            arrows: false,
                        }
                    },
                ]
                
            });
        });
    });

    document.dispatchEvent(new CustomEvent('adev:product-card:gallery-images'));

}(jQuery));